export interface EnvironmentState {
    isStandalone: boolean;
}

export const environmentInitialState: EnvironmentState = {
    isStandalone: false,
};
